<template>
  <section class="!tw-block">
    <div class="relative overflow-hidden js-section-slider" data-slider-cols="xl-2 lg-2 md-2 sm-1 base-1" data-gap="0">
      <div class="swiper-wrapper h-auto" aria-live="polite" :style="{ height: sliderHeight + 'px' }">
        <div
          v-for="(card, idx) in cards"
          :key="idx"
          class="swiper-slide"
          role="group"
          :aria-label="`${idx + 1} / ${cards.length}`"
          :style="{ width: slideWidth + 'px' }"
        >
          <div class="imageCard -type-1">
            <div class="imageCard__image ratio ratio-1:1">
              <library-iframe :src="card.video" />
            </div>
          </div>
        </div>
      </div>

      <div class="imageSliderNav">
        <button class="-prev js-prev" :disabled="!canPrev">
          <i class="icon-left-arrow"></i>
        </button>
        <button class="-next js-next" :disabled="!canNext">
          <i class="icon-right-arrow"></i>
        </button>
      </div>
      <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'VideoBox',
  mixins: [ComponentMixin],
  computed: {
    descriptions() {
      return this.groupedVariables.descriptions;
    },
    cards() {
      return this.groupedVariables.cards;
    },
  },
});
</script>
